import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as R from 'ramda';
import less from './less';
var Color = less.definitions.Color,
    _less$functions = less.functions,
    lighten = _less$functions.lighten,
    darken = _less$functions.darken,
    saturate = _less$functions.saturate;
var colorObjs = {
  red: new Color('ff6c5f'),
  orange: new Color('f2711c'),
  yellow: new Color('fda51f'),
  olive: new Color('b5cc18'),
  green: new Color('2dde98'),
  teal: new Color('1cc7d0'),
  blue: new Color('00aeff'),
  violet: new Color('8e43e7'),
  purple: new Color('b84592'),
  pink: new Color('ff6c5f'),
  brown: new Color('a5673f'),
  grey: new Color('6C6F76'),
  black: new Color('181A20'),
  'sc-teal-900': new Color('10777C'),
  'sc-teal-800': new Color('138B92'),
  'sc-teal-700': new Color('169FA6'),
  'sc-teal-600': new Color('19B3BB'),
  'sc-teal-400': new Color('3DCFD7'),
  'sc-teal-300': new Color('5FD7DE'),
  'sc-teal-200': new Color('82E0E5'),
  'sc-teal-100': new Color('A4E8EC'),
  'sc-green-900': new Color('1B855B'),
  'sc-green-800': new Color('1F9A6A'),
  'sc-green-700': new Color('24B179'),
  'sc-green-600': new Color('28C889'),
  'sc-green-400': new Color('4CE2A7'),
  'sc-green-300': new Color('6CE7B7'),
  'sc-green-200': new Color('8AECC6'),
  'sc-green-100': new Color('ABF1D5'),
  'sc-red-900': new Color('994039'),
  'sc-red-800': new Color('B24B42'),
  'sc-red-700': new Color('CC564C'),
  'sc-red-600': new Color('E56055'),
  'sc-red-400': new Color('FF8176'),
  'sc-red-300': new Color('FF978E'),
  'sc-red-200': new Color('FFAEA7'),
  'sc-red-100': new Color('FFC4BF'),
  'sc-purple-900': new Color('6E2957'),
  'sc-purple-800': new Color('813066'),
  'sc-purple-700': new Color('933774'),
  'sc-purple-600': new Color('A53D83'),
  'sc-purple-400': new Color('C260A2'),
  'sc-purple-300': new Color('CD7DB2'),
  'sc-purple-200': new Color('D898C3'),
  'sc-purple-100': new Color('E2B4D3'),
  'sc-violet-900': new Color('55288A'),
  'sc-violet-800': new Color('632FA2'),
  'sc-violet-700': new Color('7135B8'),
  'sc-violet-600': new Color('7F3CCF'),
  'sc-violet-400': new Color('9E5FEA'),
  'sc-violet-300': new Color('B07BEE'),
  'sc-violet-200': new Color('C097F1'),
  'sc-violet-100': new Color('D1B3F5'),
  'sc-yellow-900': new Color('976312'),
  'sc-yellow-800': new Color('B17315'),
  'sc-yellow-700': new Color('CA8418'),
  'sc-yellow-600': new Color('E3941B'),
  'sc-yellow-400': new Color('FDB241'),
  'sc-yellow-300': new Color('FDC062'),
  'sc-yellow-200': new Color('FDCD83'),
  'sc-yellow-100': new Color('FEDBA5'),
  'sc-blue-900': new Color('006899'),
  'sc-blue-800': new Color('0079B2'),
  'sc-blue-700': new Color('008BCC'),
  'sc-blue-600': new Color('009CE5'),
  'sc-blue-400': new Color('27BAFF'),
  'sc-blue-300': new Color('4DC6FF'),
  'sc-blue-200': new Color('73D2FF'),
  'sc-blue-100': new Color('99DEFF'),
  'sc-darkgrey-900': new Color('1B1E24'),
  'sc-darkgrey-800': new Color('20232A'),
  'sc-darkgrey-700': new Color('242830'),
  'sc-darkgrey-600': new Color('292D36'),
  'sc-darkgrey-500': new Color('2E333D'),
  'sc-darkgrey-400': new Color('424750'),
  'sc-darkgrey-300': new Color('575B63'),
  'sc-darkgrey-200': new Color('6C6F76'),
  'sc-darkgrey-100': new Color('81848A'),
  'sc-lightgrey-900': new Color('969A9D'),
  'sc-lightgrey-800': new Color('A7AAAD'),
  'sc-lightgrey-700': new Color('B8BBBC'),
  'sc-lightgrey-600': new Color('C9CCCC'),
  'sc-lightgrey-500': new Color('DBDEDD'),
  'sc-lightgrey-400': new Color('E2E4E3'),
  'sc-lightgrey-300': new Color('E9EBEA'),
  'sc-lightgrey-200': new Color('F0F1F1'),
  'sc-lightgrey-100': new Color('F7F8F8')
};
var text = {
  color: R.map(function (colorObj) {
    return colorObj.toRGB();
  })(colorObjs),
  hover: _objectSpread({}, R.pipe(R.omit(['grey, black']), R.map(function (colorObj) {
    return saturate(darken(colorObj, {
      value: 10
    }), {
      value: 10
    }, {
      value: 'relative'
    }).toRGB();
  }))(colorObjs), {}, R.pipe(R.pick(['grey, black']), R.map(function (colorObj) {
    return lighten(colorObj, {
      value: 5
    }).toRGB();
  }))(colorObjs))
};
var theme = {
  palette: {
    text: text
  },
  breakpoints: {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  }
};
export default theme;